import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ill_badge_profile_pin_lock.svg'


const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
}
const _hoisted_2 = { class: "bg-white rounded-lg p-8 w-full max-w-md mx-4 shadow-xl" }
const _hoisted_3 = { class: "flex flex-col items-center text-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "otp-activation",
  class: "w-32 mb-6"
}, null, -1)
const _hoisted_5 = { class: "text-18px font-semibold text-black-lp-300 font-montserrat mb-2" }
const _hoisted_6 = { class: "text-14px text-gray-lp-800 font-montserrat mb-6" }
const _hoisted_7 = { class: "flex flex-row w-full gap-x-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("h2", _hoisted_5, _toDisplayString(_ctx.isCountryCodeEmpty
              ? "Enable OTP verification"
              : _ctx.$t("authenticator.login.modalTitle")), 1),
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.isCountryCodeEmpty
              ? "Provide additional security by enabling OTP code verification for your account."
              : _ctx.$t("authenticator.login.modalMesssage")), 1),
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_LpButton, {
                "data-testid": "auth-otp-activation-button-activate",
                title: 
              _ctx.isCountryCodeEmpty
                ? 'Activate now'
                : _ctx.$t('authenticator.login.modalButton')
            ,
                color: "red-lp-2400",
                textColor: "white",
                "is-width-full": "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('activate')))
              }, null, 8, ["title"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}